export const primaryColor = "#A40165";
